
import Vue, { PropType } from "vue";
import DcmPropertiesForm from "../components/DcmPropertiesForm.vue";
import { DcmMetadataForm } from "../interfaces/DcmMetadataConfig";
import { DcmUploadAction } from "../interfaces/DcmListActions";
import { MetadataField } from "@/@modules/dcm/services/properties";

export default Vue.extend({
  components: { DcmPropertiesForm },
  props: {
    uploadAction: {
      type: Object as PropType<DcmUploadAction>,
      required: true,
    },
  },
  data() {
    return {
      fields: undefined as MetadataField[] | undefined,
      file: undefined as File | undefined,
      form: {} as DcmMetadataForm,
      item: { "cmis.objectTypeId": this.uploadAction.objectTypeId },
      valid: false,
    };
  },
  created() {
    this.fields = this.uploadAction.metadataFields[this.uploadAction.objectTypeId];
  },
  methods: {
    createDocAndUpload() {
      if (this.fields && this.file) {
        for (const { metadataName, typeOfField, isRequired } of this.fields) {
          if (isRequired && isRequired() && typeOfField === "checkbox" && this.form[metadataName] === undefined) {
            this.form[metadataName] = false;
          }
        }
        Object.assign(this.form, this.uploadAction.getDefaultMetadata());

        if (this.uploadAction.formatFileName) {
          const newFileName = this.uploadAction.formatFileName(this.form, this.file.name);
          this.file = new File([this.file], newFileName, {
            lastModified: this.file.lastModified,
            type: this.file.type,
          });
        }

        const path = this.uploadAction.getPath(this.uploadAction.sites, this.form);

        this.$modal.close({ file: this.file, metadata: this.form, path });
      }
    },
    handleError() {
      this.$modal.close(false);
      this.$snackbar.show("Cannot upload document: missing fields", 10000, [{ label: "close", value: "" }], {
        error: true,
      });
    },
    async onInput() {
      if (this.file && (this.uploadAction.checkFile || this.uploadAction.setFileBasedMetadata)) {
        try {
          if (this.uploadAction.checkFile) {
            await this.uploadAction.checkFile(this.file);
          }
          if (this.uploadAction.setFileBasedMetadata) {
            await this.uploadAction.setFileBasedMetadata(this.file, this.form);
          }
        } catch (error) {
          this.file = undefined;
          this.$snackbar.show(`Wrong file: ${error}`, 10000, [], { error: true });
          console.error(error);
        }
      }
    },
  },
});
